import React from 'react';
import { BannerReact } from 'common/components/banner';
import { BannerTheme, BannerType } from 'common/components/banner/types';
import { useTranslation } from 'common/i18n/hooks';
import { useExperimentsStore } from 'apps/experiments/src/store';
import { SelectTheme } from 'common/components/select/constants';
import { SvgIconReact } from 'common/components/svg-icon';
import { formatSignificantResults } from './helper';
import { ExposuresMakeDecision } from './_exposures-make-decision';
export function ExperimentPageBannerReview() {
  var _experiment$results_c, _experiment$results_c2;
  const i18n = useTranslation();
  const experiment = useExperimentsStore(state => state.experiment)!;
  const {
    significantResults
  } = formatSignificantResults(i18n, (_experiment$results_c = (_experiment$results_c2 = experiment.results_cache) === null || _experiment$results_c2 === void 0 ? void 0 : _experiment$results_c2.summary) !== null && _experiment$results_c !== void 0 ? _experiment$results_c : {});
  return <>
      <BannerReact headerText={i18n.t("experiments.banner.review.title")} bodyText={significantResults} theme={BannerTheme.Base} type={BannerType.Embedded} data-sentry-element="BannerReact" data-sentry-source-file="_review.tsx">
        <div slot={"icon"}>
          <SvgIconReact icon='circle-checkmark' color='var(--primary-color)' data-sentry-element="SvgIconReact" data-sentry-source-file="_review.tsx" />
        </div>
        <div slot={"cta"}>
          <ExposuresMakeDecision theme={SelectTheme.Primary} label={i18n.t("experiments.banner.common.exposures-make-decision.label")} alwaysShowCaret data-sentry-element="ExposuresMakeDecision" data-sentry-source-file="_review.tsx" />
        </div>
      </BannerReact>
    </>;
}